import { useEffect, useState, useMemo } from "react";
import React from 'react';
import ReactTableWrapper from "../../components/ReactTableWrapper";
import { exportAsCSV } from "../../utils/CSVExporter";
import { exportAsPDF } from "../../utils/PDFExporter";
import { openPdfResponse } from "../../utils/openPdfInApp";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import Swal from "sweetalert2";
import { useCookies } from 'react-cookie';
import {Row, Col, Button} from "reactstrap";
import { default as ReactSelect } from "react-select";
import {getDispatchReportSummaryCSV,getDispatchReportSummary} from "../../services/ReportServices";
import {  DatePicker } from 'antd';
import { getUserAllowedPlants} from '../../services/PlantServices';
import { getAllCustomerMain} from '../../services/CustomerMainServices';
import { getAllSalesRepresentatives } from '../../services/SalesRepresentativeServices';
import {getAllCustomerSites} from '../../services/CustomerSiteServices';
import { mapConsigneeListToSiteOptions } from '../../utils/customerSiteOptionsUtils';
import { getAllProducts } from "../../services/ProductServices";
import moment  from 'moment';
import {displayErrorToast,displayError,parseBoolean,parseBooleanToString} from '../../helpers';
import {HandleSelect,ValueContainer,Option} from "../../components/MultiSelectControls";
import ReportExportDropdown from '../../components/ReportExportDropdown';
import ReportFilterToggleBar from '../../components/ReportFilterToggleBar';
const {RangePicker} = DatePicker;

function DispatchReportSummary() 
{
    const InitialData = {
        total_pages: 0,
        records: [],
      };
    const [data, setData] = useState(InitialData);
    const navigate = useNavigate(); 
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(false);
    const [plants, setPlants] = useState([]);
    const [selectedPlant, setSelectedPlant] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [selectedSalesrep, setSelectedSalesRep] = useState([]);
    const [salesreps, setSalesreps] = useState([]);
    const [selectedSite, setSelectedSite] = useState([]);
    const [sites, setSites] = useState([]);
    const [selectedGrade, setSelectedGrade] = useState([]);
    const [grades, setGrades] = useState([]);
    const [inputs, setInputs] = useState({ report_format: 'datewise' });
    const [downloadOption, setDownloadOption] = useState('');
    const [totalDcQty, setTotalDcQty] = useState('0.00');
    const [totalAmount, setTotalAmount] = useState('0.00');
    const [filtersVisible, setFiltersVisible] = useState(true);

    // Initial state for from_date and to_date
    const initialFromDate = moment().startOf('month');
    const initialToDate =  moment();
    const [fromDate, setFromDate] = useState(initialFromDate);
    const [toDate, setToDate] = useState(initialToDate);
    const handleDateChange = (values) => {
        if ((values) && (values.length === 2)) {
        setFromDate(values[0]);
        setToDate(values[1]);
        }
    };

    React.useEffect(() => {
        //Load data for Plant dropdown
        getUserAllowedPlants(cookies)
        .then (
            plantList => {
                const plants = plantList.plant_list.map(
                    plant => {
                        return { value: plant.id, label: plant.plant_alias }
                    }
                );
                setPlants(plants);
                setSelectedPlant(values =>[...values,...plants, ...plantsWithSelectAll]);
            }
        )
    }, []);

    React.useEffect(() => {
        getAllCustomerMain(cookies)
        .then (
            customerList => {
                const customers = customerList.customer_list.map(
                    customer => {
                        return { value: customer.id, label: customer.name }
                    }
                );
                setCustomers(customers);
                setSelectedCustomer(values =>[...values,...customers, ...customersWithSelectAll]);
            }
        )
    }, []);

    React.useEffect(() => {
    getAllCustomerSites(cookies)
    .then (
        siteList => {
            const sites = mapConsigneeListToSiteOptions(siteList.consignee_list);
            setSites(sites);
            setSelectedSite(values =>[...values,...sites, ...sitesWithSelectAll]);
        }
    )
    .catch(() => {
        setSites([]);
    });
    }, []);

    React.useEffect(() => {
        getAllSalesRepresentatives(cookies)
        .then (
            salesRepList => {
                const salesrep = salesRepList.salesrep_data.map(
                sales => {
                        return { value: sales.id, label: sales.entity_name }
                    }
                );
                //console.log(JSON.stringify(salesRepList)+"salesRepList")
                setSalesreps(salesrep);
                setSelectedSalesRep(values =>[...values,...salesrep, ...salesrepsWithSelectAll]);
            }
        )
    }, []);


    React.useEffect(() => {
        getAllProducts(cookies)
        .then (
            productList => {
                const products = productList.product_list.map(
                    product => {
                        return { value: product.id, label: product.name}
                    }
                )
                setGrades(products);
                setSelectedGrade(values =>[...values,...products, ...gradesWithSelectAll]);
            }
        )
    }, []);

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        console.log(name+value+"name and value")
        setInputs(values => ({...values, [name]: event.target.value}))
    }

    // Add a "Select All" option to the plants array
    const plantsWithSelectAll = [
        { value: "select-all", label: "Select All plants" },
        ...plants,
    ];

    // Add a "Select All" option to the customers array
    const customersWithSelectAll = [
        { value: "select-all", label: "Select All customers" },
        ...customers,
    ];
    
    // Add a "Select All" option to the sites array
    const sitesWithSelectAll = [
        { value: "select-all", label: "Select All sites" },
        ...sites,
    ];
    
    // Add a "Select All" option to the salesreps array
    const salesrepsWithSelectAll = [
        { value: "select-all", label: "Select All sales representatives" },
        ...salesreps,
    ];  
    
    // Add a "Select All" option to the grades array
    const gradesWithSelectAll = [
        { value: "select-all", label: "Select All grades" },
        ...grades,
    ];
      
    const onPlantSelect = (selected) => {
        HandleSelect(selected,selectedPlant,setSelectedPlant, plants, plantsWithSelectAll);
    };
    
    const onCustomerSelect = (selected) => {
        HandleSelect(selected,selectedCustomer, setSelectedCustomer, customers, customersWithSelectAll);
    };
    
    const onSiteSelect = (selected) => {
        HandleSelect(selected,selectedSite, setSelectedSite, sites, sitesWithSelectAll);
    };
        
    const onSalesRepSelect = (selected) => {
        HandleSelect(selected,selectedSalesrep, setSelectedSalesRep, salesreps, salesrepsWithSelectAll);
    };

    const onGradeSelect = (selected) => {
        HandleSelect(selected,selectedGrade, setSelectedGrade, grades, gradesWithSelectAll);
    };

    const areAllPlantsSelected = () => {
        // Check if all plants are selected
        return plants.every((plant) =>
          selectedPlant ? selectedPlant.some((selected) => selected.value === plant.value) : false
        );
    };

    const areAllCustomersSelected = () => {
        // Check if all customers are selected
        return customers.every((customer) =>
            selectedCustomer ? selectedCustomer.some((selected) => selected.value === customer.value) : false
        );
    };

    const areAllConsigneesSelected = () => {
        // Check if all consignees are selected
        return sites.every((consignee) =>
        selectedSite ? selectedSite.some((selected) => selected.value === consignee.value) : false
        );
    };

    const areAllSalesRepsSelected = () => {
        // Check if all salesreps are selected
        return salesreps.every((salesrep) =>
        selectedSalesrep ? selectedSalesrep.some((selected) => selected.value === salesrep.value) : false
        );
    };
    
    const areAllGradesSelected = () => {
        // Check if all grades are selected
        return grades.every((grade) =>
        selectedGrade ? selectedGrade.some((selected) => selected.value === grade.value) : false
        );
    };

    const Home = () => {
        navigate('/Home')
    }

    const columns = useMemo(
        () => [
            {
                fieldName: 'plant_alias', 
                headerName: 'Plant'
            },
            {
                fieldName: "delivery_challan_date",
                headerName: 'Date'
            },
            {
                fieldName: "purchase_order_no",
                headerName: 'PO Number'
            },
            {
                fieldName: 'customer_name', 
                headerName: 'Customer Name'
            },
            {
                fieldName: "project_name",
                headerName: 'Site/Project Name'
            },
            {
                fieldName: 'dc_grade', 
                headerName: 'DC Grade'
            },
            {
                fieldName: 'dc_qty', 
                headerName: 'DC Qty'
            },
            {
                fieldName: 'rate', 
                headerName: 'Rate'
            },
            {
                fieldName: 'amount', 
                headerName: 'Amount'
            },
            {
                fieldName: 'delivery_mode', 
                headerName: 'Mode of Delivery'
            },
            {
                fieldName: "salesrep_name",
                headerName: 'Marketting'
            },
        ],
        [],);
   
    const handleCSVExport = (event) => {
    };

    const handlePDFExport = (event) => {
    };

    const constructFormData = () => {
        const EMPTY_STRING = '';
        return {
            plant_ids:areAllPlantsSelected()? '*' // Send '*' if all plants are selected
            : selectedPlant.map((plant) => plant.value).join(','),
            customer_ids:areAllCustomersSelected()? '*' // Send '*' if all customers are selected
            : selectedCustomer.map((customer) => customer.value).join(','),
            consignee_ids:areAllConsigneesSelected()? '*' // Send '*' if all consignees are selected
            : selectedSite.map((consignee) => consignee.value).join(','),
            sales_rep_ids:areAllSalesRepsSelected()? '*' // Send '*' if all salesreps are selected
            : selectedSalesrep.map((salesrep) => salesrep.value).join(','),
            product_ids:areAllGradesSelected()? '*' // Send '*' if all grades are selected
            : selectedGrade.map((grade) => grade.value).join(','),
            from_date:fromDate.format('DD-MM-YYYY'),
            upto_date:toDate.format('DD-MM-YYYY'),
            report_format:inputs.report_format,
            download_option:downloadOption
          }
    }

    const handleGenerate = () => {
        const formInputs = constructFormData();
        formInputs.download_option = '';
        if ((formInputs.plant_ids) && (formInputs.customer_ids) && (formInputs.consignee_ids) && (formInputs.sales_rep_ids) &&
        (formInputs.product_ids) && (formInputs.from_date) && (formInputs.upto_date) && (formInputs.report_format))
        {
            setIsLoading(true);
            getDispatchReportSummary(cookies, formInputs)
            .then(response => {
                const tableData = (response.dispatch_report_summary_list || [])
                .map(dc => ({
                    plant_name: dc.plant_name,
                    plant_alias: dc.plant_alias,
                    production_plant_name: dc.production_plant_name,
                    id: dc.id,
                    customer_id:dc.customer_id,
                    delivery_challan_date: dc.delivery_challan_date,
                    delivery_challan_time: dc.delivery_challan_time,
                    purchase_order_no:dc.purchase_order_no,
                    customer_name:dc.customer_name,
                    project_name:dc.project_name,
                    dc_grade:  dc.dc_grade,
                    dc_qty: dc.dc_qty,
                    rate: dc.rate,
                    amount:  dc.amount,
                    delivery_mode: (dc.delivery_mode || '').toUpperCase(),
                    salesrep_name: dc.salesrep_name,
                }));
                setData({ records: tableData });
                const qtyTotal = tableData.reduce((sum, row) => sum + Number(row.dc_qty || 0), 0);
                const amountTotal = tableData.reduce((sum, row) => sum + Number(row.amount || 0), 0);
                setTotalDcQty(qtyTotal.toFixed(2));
                setTotalAmount(amountTotal.toFixed(2));
                setFiltersVisible(false);
                setIsLoading(false);
            }).catch((error) => {
                console.log(error.response?.data);
                displayError(error.response?.data);
                setIsLoading(false);
            });
        }
        else
        {
            setData({ records: [] });
            setTotalDcQty('0.00');
            setTotalAmount('0.00');
            Swal.fire("plant,customer,consignee,sales_rep,product,from_date,upto_date,report format must not be empty.", "", "info");
        }
    };

    const handleSubmit=(event)=>
    {
        event.preventDefault();
        handleGenerate();
    }

        const handleDownloadPdf = () => {
            // setDownloadOption('pdf')
            console.log(JSON.stringify(constructFormData())+"submit handleDownloadPdf")
            const inputs = constructFormData();
            inputs.download_option = 'pdf';
            console.log(JSON.stringify(inputs)+"inputs submit handleDownloadPdf")
            setData({
                records: []
            });
            if ((inputs.plant_ids) && (inputs.customer_ids) && (inputs.consignee_ids) && (inputs.sales_rep_ids) && 
           (inputs.product_ids) && (inputs.from_date) && (inputs.upto_date)&& (inputs.report_format))
            {
                getDispatchReportSummary(cookies, inputs)
                .then(response => {
                    openPdfResponse(response, {
                        title: 'Dispatch Report Summary',
                        downloadFileName: 'Dispatch_report_summary.pdf',
                    });
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.log(error.response?.data);
                    displayError(error.response?.data);
                });
            }
            else 
            {

                Swal.fire("plant,customer,consignee,sales_rep,product,from_date,upto_date,report format must not be empty.", "", "info");  
            }
        };

        const handleDownloadCsv = () => {
            // setDownloadOption('csv')
            console.log(JSON.stringify(constructFormData())+"submit")
            const inputs = constructFormData();
            setData({
                records: []
            });
            if ((inputs.plant_ids) && (inputs.customer_ids) && (inputs.consignee_ids) && (inputs.sales_rep_ids) && 
            (inputs.product_ids) && (inputs.from_date) && (inputs.upto_date)&& (inputs.report_format))
            {
                getDispatchReportSummaryCSV(cookies, constructFormData())
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'dispatch_report_summary.csv');
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                })
                .catch((error) => {
                    console.log(error.response.data);
                    displayError(error.response.data);
                });
            }
            else 
            {
                Swal.fire("plant,customer,consignee,sales_rep,product,from_date,upto_date,report format must not be empty.", "", "info");  
            }
        };

    return (
            <div className="report-embedded-page">
                {!filtersVisible ? (
                    <div className="container">
                        <ReportFilterToggleBar onShow={() => setFiltersVisible(true)} />
                    </div>
                ) : null}
                {filtersVisible ? (
                <form className="form" onSubmit={handleSubmit}>
                    <div className="container"> 
                       <Row> 
                            <Col xl={12} lg={12} md={12}>
                                <div className="report-legacy-filters form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel">
                                        <div className="report-legacy-filters-fields">
                                        <ReactSelect
                                            options={plantsWithSelectAll}
                                            isMulti={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{Option, ValueContainer}}
                                            isClearable={true}
                                            value={selectedPlant}
                                            onChange={onPlantSelect}
                                            className="react-select-dropdown col-sm-3"
                                            placeholder="Please select Plant name"
                                        />
                                        <ReactSelect
                                            options={customersWithSelectAll}
                                            isMulti={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{Option, ValueContainer}}
                                            isClearable={true}
                                            value={selectedCustomer}
                                            onChange={onCustomerSelect}
                                            className="react-select-dropdown col-sm-3"
                                            placeholder="Please select Customer"
                                        />
                                        <ReactSelect
                                            options={sitesWithSelectAll}
                                            isMulti={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{Option, ValueContainer}}
                                            isClearable={true}
                                            value={selectedSite}
                                            onChange={onSiteSelect}
                                            className="react-select-dropdown col-sm-3"
                                            placeholder="Please Select Site"
                                        />
                                        <ReactSelect
                                            options={salesrepsWithSelectAll}
                                            isMulti={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{Option, ValueContainer}}
                                            isClearable={true}
                                            value={selectedSalesrep}
                                            onChange={onSalesRepSelect}
                                            className="react-select-dropdown col-sm-3"
                                            placeholder="Please Select SalesRep"
                                        />
                                        <ReactSelect
                                            options={gradesWithSelectAll}
                                            isMulti={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{Option, ValueContainer}}
                                            isClearable={true}
                                            value={selectedGrade}
                                            onChange={onGradeSelect}
                                            className="react-select-dropdown col-sm-3"
                                            placeholder="Please Select Grade"
                                        />
                                        </div>
                                        <div className="report-legacy-filters-row">
                                        <RangePicker
                                            defaultValue={[initialFromDate, initialToDate]}
                                            format="DD-MM-YYYY"
                                            onChange={handleDateChange}
                                            style={{width:"270px"}}
                                        />
                                        <select
                                            className="browser-default custom-select col-sm-3"
                                            onChange={handleChange}
                                            value={inputs.report_format || 'datewise'}
                                            name="report_format"
                                            style={{width:"200px"}}
                                        >
                                            <option value="all">All</option>
                                            <option value="datewise">Datewise</option>
                                            <option value="customerwise">Customerwise</option>
                                        </select>
                                        <div className="report-legacy-actions">
                                        <ReportExportDropdown
                                            onCSV={handleDownloadCsv}
                                            onPDF={handleDownloadPdf}
                                            disabled={isLoading}
                                        />
                                        <Button
                                            color="primary"
                                            className="list-page-toolbar-generate-btn"
                                            type="button"
                                            onClick={handleGenerate}
                                            disabled={isLoading}
                                        >
                                            Generate
                                        </Button>
                                        </div>
                                        </div>
                                </div>
                             </Col>
                        </Row>
                    </div> 
                </form>
                ) : null}
                <div className="container">
                        {data.records.length > 0 ? (
                                <div className="list-page-summary-bar">
                                    <div className="list-page-summary-primary">
                                        <span className="list-page-summary-label">FILTERED VIEW</span>
                                        <span className="list-page-summary-count">
                                            {data.records.length} {data.records.length === 1 ? 'row' : 'rows'}
                                        </span>
                                    </div>
                                    <div className="list-page-summary-metrics">
                                        <div className="list-page-metric-card">
                                            <span className="list-page-metric-label">Total DC Qty</span>
                                            <span className="list-page-metric-value is-yellow">{totalDcQty}</span>
                                        </div>
                                        <div className="list-page-metric-card">
                                            <span className="list-page-metric-label">Total Amount</span>
                                            <span className="list-page-metric-value">{totalAmount}</span>
                                        </div>
                                        <div className="list-page-metric-card">
                                            <span className="list-page-metric-label">Summary Lines</span>
                                            <span className="list-page-metric-value is-b2b">{data.records.length}</span>
                                        </div>
                                    </div>
                                </div>
                        ) : null}
                    <div className="list-page-table-wrap">
                        <div className="item-list-table-container">
                            <div className="table-responsive">
                                <ReactTableWrapper
                                    title='Dispatch Report Summary'
                                    columns={columns}
                                    data={data.records}
                                    exportFilename="dispatch_report_summary"
                                    enableTableSearch={false}
                                    isLoading={isLoading}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
);
}

export default DispatchReportSummary;